import type { UserRoles } from '@sparkai/shared-types'

export type ShareLinkTargetApp =
  | 'admin'
  | 'customer'
  | 'mission-specialist'
  | 'workforce-manager'
  | 'unsupported'

const SHARE_LINK_TARGET_BY_ROLE: Record<UserRoles, ShareLinkTargetApp> = {
  account_owner: 'customer',
  admin: 'admin',
  applicant: 'mission-specialist',
  bot: 'unsupported',
  customer: 'customer',
  new_user: 'unsupported',
  operator: 'mission-specialist',
  platform_user: 'unsupported',
  trainee: 'mission-specialist',
  workforce_manager: 'workforce-manager',
}

export function getBaseShareLinkTargetApp(role?: UserRoles): ShareLinkTargetApp {
  return role ? (SHARE_LINK_TARGET_BY_ROLE[role] ?? 'unsupported') : 'unsupported'
}
